import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const isIE = /msie\s|trident\//i.test(window.navigator.userAgent);

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.clientId,
    authority: environment.authority,
    redirectUri: environment.appUrl,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
      loggerCallback: (level, message) => console.log('[MSAL]', LogLevel[level], message),
    },
  },
});
